import { render, staticRenderFns } from "./loanprepaid.vue?vue&type=template&id=b3fb1c36&"
import script from "./loanprepaid.vue?vue&type=script&lang=js&"
export * from "./loanprepaid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports